import React, { useState } from "react";
import { Col, Row, Form, Input, Button, message } from "antd";
function PaymentDiscount({ onApplyDiscount, loading, error }) {

  return (
    <Form layout="vertical" onFinish={onApplyDiscount} style={{marginTop: 30}}>
      <Row gutter={15}>
        <Col xs={12}>
          <Form.Item
            name="code"
            id="code"
            label="کد تخفیف"
            
            validateStatus={error && "error"}
            help={error}
          >
            <Input className="form-input" placeholder={"کد تخفیف"} />
          </Form.Item>
        </Col>
        <Col xs={10}>
          <Button type="primary" htmlType="submit" loading={loading} style={{marginTop: 33}}>
            اعمال
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default PaymentDiscount;
